<template>
  <fragment>
    <div class="card-on-card card-outline-secondary">
      <div class="card-header">
        <h5 class="mb-2 font-weight-bold"><b> Spesifikasi</b></h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-row mb-4 mb-4">
              <label class="col-md col-form-label" for="name"
                >Barang Asal</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookOrigin"
                  id="bookOrigin"
                >
                  <option value="Dalam Negri">Dalam Negri</option>
                  <option value="Luar Negri">Luar Negri</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">Kertas Isi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookFillPaper"
                  id="bookFillPaper"
                >
                  <option value="HVS 70">HVS 70</option>
                  <option value="HVS 70">HVS 80</option>
                  <option value="HVS 70">HVS 100</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name"
                >Barang Produsen</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookProducer"
                  id="bookProducer"
                >
                  <option value="UMKM">UMKM</option>
                  <option value="Non UMKM">Non UMKM</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Kertas Cover</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookCoverPaper"
                  id="bookCoverPaper"
                >
                  <option value="Art Carton 210">Art Carton 210</option>
                  <option value="HVS 70">HVS 70</option>
                  <option value="HVS 70">HVS 80</option>
                  <option value="HVS 70">HVS 100</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Berat (Kg)</label>
              <div class="col-lg-4">
                <input
                  type="number"
                  name="bookWeigth"
                  id="bookWeigth"
                  class="form-control"
                  placeholder="0"
                  @keyup="validateNotNull('bookWeigth')"
                  step="0.1"
                  value="0.2"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                />
                <span class="invalid-feedback"
                  >Berat tidak boleh kosong / angka 0</span
                >
                <span class="small text-muted"
                  >Gunakan tanda . untuk menuliskan koma (misal: 0.200)</span
                >
              </div>
              <label class="col-md col-form-label" for="name">Warna Isi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookFillColor"
                  id="bookFillColor"
                >
                  <option value="Full Color">Full Color</option>
                  <option value="Black White">Black White</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name"
                >Dimensi (Cm)</label
              >
              <div class="col-md-4">
                <div class="input-group mb-3">
                  <span class="input-group-text">P</span>
                  <input
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    type="number"
                    name="bookLength"
                    id="bookLength"
                    class="form-control"
                    placeholder="0"
                    value="0"
                    aria-label="Username"
                  />
                  <span class="input-group-text">L</span>
                  <input
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    type="number"
                    name="bookWidth"
                    id="bookWidth"
                    class="form-control"
                    placeholder="0"
                    value="0"
                    aria-label="Server"
                  />
                  <span class="input-group-text">T</span>
                  <input
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    type="number"
                    name="bookHeight"
                    id="bookHeight"
                    class="form-control"
                    placeholder="0"
                    value="0"
                    aria-label="Server"
                  />
                </div>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Warna Cover</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="warnaCover"
                  id="warnaCover"
                >
                  <option value="Full Color">Full Color</option>
                  <option value="Black White">Black White</option>
                </select>
              </div>
            </div>

            <div class="form-row mb-4 mb-4">
              <label class="col-md col-form-label" for="name">Status</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookStatus"
                  id="bookStatus"
                >
                  <option value="1">Enable (Aktif)</option>
                  <option value="0">Disable (Tidak Aktif)</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>

              <label class="col-md col-form-label" for="name">Finishing</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookFinishing"
                  id="bookFinishing"
                >
                  <option value="Uv Varninsh">Uv Varninsh</option>
                  <option value="Laminating">Laminating</option>
                  <option value="Hard Cover">Hard Cover</option>
                  <option value="Embos">Embos</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4 mb-4">
              <div class="col-lg-6"></div>
              <label class="col-md col-form-label" for="name">Penjilidan</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="bookBinding"
                  id="bookBinding"
                >
                  <option value="Perfect Binding">Perfect Binding</option>
                  <option value="Spiral">Spiral</option>
                  <option value="Jahit Benang">Jahit Benang</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
// import axios from "axios";
import $ from "jquery";

export default {
  methods: {
    validateNotNull(idEl) {
      let element = $(`#${idEl}`);

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else if (element.val() == 0 && element.val() !== "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
  },
};
</script>